import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=2899e324&scoped=true"
import script from "./tableData.vue?vue&type=script&lang=js"
export * from "./tableData.vue?vue&type=script&lang=js"
import style0 from "./tableData.vue?vue&type=style&index=0&id=2899e324&prod&lang=css"
import style1 from "./tableData.vue?vue&type=style&index=1&id=2899e324&prod&lang=less&scoped=true"
import style2 from "./tableData.vue?vue&type=style&index=2&id=2899e324&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899e324",
  null
  
)

export default component.exports